import * as stylex from "@stylexjs/stylex";
import { colors, fonts, fontSizes } from "@softmax/design-system/tokens.stylex";

import type { StoreDiagramBoard } from "./play-diagram-records";

export function BoardArtifact({
  board,
}: {
  readonly board: StoreDiagramBoard;
}) {
  if (board.kind === "empty")
    return <p {...stylex.props(styles.empty)}>No board yet</p>;

  if (board.kind === "board") {
    return (
      <div {...stylex.props(styles.boardSlot)}>
        <div {...stylex.props(styles.boardNative)}>{board.content}</div>
      </div>
    );
  }

  return (
    <div {...stylex.props(styles.boardSlot, styles.capture)}>
      <img src={board.src} alt={board.alt} {...stylex.props(styles.image)} />
    </div>
  );
}

const styles = stylex.create({
  empty: {
    margin: 0,
    textAlign: "center",
    fontFamily: fonts.sans,
    fontSize: fontSizes.caption,
    lineHeight: "15px",
    color: colors.muted,
    fontStyle: "italic",
  },
  boardSlot: {
    position: "relative",
    overflow: "hidden",
    width: {
      default: 144,
      "@container (min-width: 560px)": 150,
      "@container (min-width: 700px)": 190,
    },
    height: {
      default: 144,
      "@container (min-width: 560px)": 150,
      "@container (min-width: 700px)": 190,
    },
    flexShrink: 0,
  },
  boardNative: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  capture: { borderRadius: 4 },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center",
  },
});
